// Girl Names (U.S.) card game data with rankings
export const GIRL_NAME_CARDS = [
  {
    "id": 1,
    "name": "Mary",
    "rank": 1,
    "image": "/images/girlName/girlName_1.jpg"
  },
  {
    "id": 2,
    "name": "Patricia",
    "rank": 2,
    "image": "/images/girlName/girlName_2.jpg"
  },
  {
    "id": 3,
    "name": "Jennifer",
    "rank": 3,
    "image": "/images/girlName/girlName_3.jpg"
  },
  {
    "id": 4,
    "name": "Linda",
    "rank": 4,
    "image": "/images/girlName/girlName_4.jpg"
  },
  {
    "id": 5,
    "name": "Elizabeth",
    "rank": 5,
    "image": "/images/girlName/girlName_5.jpg"
  },
  {
    "id": 6,
    "name": "Barbara",
    "rank": 6,
    "image": "/images/girlName/girlName_6.jpg"
  },
  {
    "id": 7,
    "name": "Susan",
    "rank": 7,
    "image": "/images/girlName/girlName_7.jpg"
  },
  {
    "id": 8,
    "name": "Jessica",
    "rank": 8,
    "image": "/images/girlName/girlName_8.jpg"
  },
  {
    "id": 9,
    "name": "Karen",
    "rank": 9,
    "image": "/images/girlName/girlName_9.jpg"
  },
  {
    "id": 10,
    "name": "Sarah",
    "rank": 10,
    "image": "/images/girlName/girlName_10.jpg"
  },
  {
    "id": 11,
    "name": "Lisa",
    "rank": 11,
    "image": "/images/girlName/girlName_11.jpg"
  },
  {
    "id": 12,
    "name": "Nancy",
    "rank": 12,
    "image": "/images/girlName/girlName_12.jpg"
  },
  {
    "id": 13,
    "name": "Sandra",
    "rank": 13,
    "image": "/images/girlName/girlName_13.jpg"
  },
  {
    "id": 14,
    "name": "Ashley",
    "rank": 14,
    "image": "/images/girlName/girlName_14.jpg"
  },
  {
    "id": 15,
    "name": "Emily",
    "rank": 15,
    "image": "/images/girlName/girlName_15.jpg"
  },
  {
    "id": 16,
    "name": "Kimberly",
    "rank": 16,
    "image": "/images/girlName/girlName_16.jpg"
  },
  {
    "id": 17,
    "name": "Betty",
    "rank": 17,
    "image": "/images/girlName/girlName_17.jpg"
  },
  {
    "id": 18,
    "name": "Margaret",
    "rank": 18,
    "image": "/images/girlName/girlName_18.jpg"
  },
  {
    "id": 19,
    "name": "Donna",
    "rank": 19,
    "image": "/images/girlName/girlName_19.jpg"
  },
  {
    "id": 20,
    "name": "Michelle",
    "rank": 20,
    "image": "/images/girlName/girlName_20.jpg"
  },
  {
    "id": 21,
    "name": "Carol",
    "rank": 21,
    "image": "/images/girlName/girlName_21.jpg"
  },
  {
    "id": 22,
    "name": "Amanda",
    "rank": 22,
    "image": "/images/girlName/girlName_22.jpg"
  },
  {
    "id": 23,
    "name": "Melissa",
    "rank": 23,
    "image": "/images/girlName/girlName_23.jpg"
  },
  {
    "id": 24,
    "name": "Deborah",
    "rank": 24,
    "image": "/images/girlName/girlName_24.jpg"
  },
  {
    "id": 25,
    "name": "Stephanie",
    "rank": 25,
    "image": "/images/girlName/girlName_25.jpg"
  },
  {
    "id": 26,
    "name": "Rebecca",
    "rank": 26,
    "image": "/images/girlName/girlName_26.jpg"
  },
  {
    "id": 27,
    "name": "Sharon",
    "rank": 27,
    "image": "/images/girlName/girlName_27.jpg"
  },
  {
    "id": 28,
    "name": "Laura",
    "rank": 28,
    "image": "/images/girlName/girlName_28.jpg"
  },
  {
    "id": 29,
    "name": "Cynthia",
    "rank": 29,
    "image": "/images/girlName/girlName_29.jpg"
  },
  {
    "id": 30,
    "name": "Amy",
    "rank": 30,
    "image": "/images/girlName/girlName_30.jpg"
  }
];
